import React from 'react';
import { Input } from './ui/input';

const SALUTATIONS = ['Mr.', 'Mrs.', 'Ms.', 'Miss', 'M/s'];
const RELATIONS = ['Son of', 'Daughter of', 'Wife of', 'Husband of'];
const REL_REGEX = /\s*(son of|daughter of|wife of|husband of)\s*/i;

const PERSON_KEYWORDS = [
  'owner', 'present owner', 'executed', 'executant', 'seller', 'vendor', 'vendee',
  'purchaser', 'favour', 'favor', 'buyer', 'khatedar', 'grantee', 'grantor',
  'gpa', 'spa', 'heir', 'legal representative', 'plaintiff', 'defendant', 'witness',
  'claimant', 'applicant', 'deceased', 'testator', 'donor', 'donee', 'lessor',
  'lessee', 'mortgagor', 'mortgagee', 'father', 'mother', 'spouse', 'transferor',
  'transferee', 'family member', 'member name', 'person',
];

export const isPersonNameField = (field) => {
  if (!field) return false;
  if (field.person_name === true) return true;
  const t = field.type || 'text';
  if (!['text', 'string', undefined, '', null].includes(t)) return false;
  const key = `${field.name || ''} ${field.label || ''}`.toLowerCase();
  if (/\bson of\b/.test(key)) return true;
  return PERSON_KEYWORDS.some((k) => key.includes(k));
};

const applySalutation = (text, sal) => {
  let t = (text || '').replace(/^\s+/, '');
  for (const s of SALUTATIONS) {
    const low = t.toLowerCase();
    if (low.startsWith(s.toLowerCase() + ' ') || low === s.toLowerCase()) {
      t = t.slice(s.length).replace(/^\s+/, '');
      break;
    }
  }
  return `${sal} ${t}`.replace(/\s+$/, ' ').trimStart();
};

const applyRelation = (text, rel) => {
  const relLower = rel.toLowerCase();
  let t = (text || '').replace(/\s+$/, '');
  if (REL_REGEX.test(t)) {
    // Swap the existing relationship keyword, keep the name that follows it
    return t.replace(REL_REGEX, ` ${relLower} `).replace(/\s{2,}/g, ' ');
  }
  if (!t) return `${relLower} `;
  return `${t} ${relLower} `;
};

export const NameHelperInput = ({ id, value, onChange, placeholder, testId }) => {
  return (
    <div className="space-y-1.5">
      <div className="flex gap-2">
        <select
          value=""
          onChange={(e) => { if (e.target.value) onChange(applySalutation(value, e.target.value)); }}
          className="h-8 rounded-md border border-slate-300 bg-slate-50 px-2 text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-slate-400"
          data-testid={testId ? `${testId}-salutation` : undefined}
          aria-label="Salutation"
        >
          <option value="">＋ Salutation</option>
          {SALUTATIONS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select
          value=""
          onChange={(e) => { if (e.target.value) onChange(applyRelation(value, e.target.value)); }}
          className="h-8 rounded-md border border-slate-300 bg-slate-50 px-2 text-xs text-slate-700 focus:outline-none focus:ring-1 focus:ring-slate-400"
          data-testid={testId ? `${testId}-relation` : undefined}
          aria-label="Relationship"
        >
          <option value="">＋ Relationship</option>
          {RELATIONS.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>
      <Input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
};

export default NameHelperInput;
